import { AutoAwesome } from '@mui/icons-material';
import { Box, Button, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import PseudonymizeCheckbox from '~/components/ModelSelection/PseudonymizeCheckbox';
import { dosePredictionTaskState } from '~/state/atoms/dose/dosePredictionTaskAtom';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import DoseStructuresTable from './DoseStructuresTable';
import ModelParameters from './ModelParameters';
import ModelSelect from './ModelSelect';

export default function DoseModelSelection({
    availableModels,
    isLoadingModels,
    showPseudonymization,
    isLoadingSession,
    isSubmitting,
    onSubmit,
}: {
    availableModels?: PredictionModel[];
    isLoadingModels: boolean;
    showPseudonymization: boolean;
    isLoadingSession?: boolean;
    isSubmitting?: boolean;
    onSubmit: (modelName: string) => void;
}) {
    const dosePredictionTask = useRecoilValue(dosePredictionTaskState);
    return (
        <Box display="flex" flexDirection="column" gap={1.5}>
            <Box display="flex" gap={1}>
                <ModelSelect
                    availableModels={availableModels}
                    isLoadingModels={isLoadingModels}
                />
            </Box>
            <DoseStructuresTable isLoading={isLoadingSession} />
            <Box>
                <Box display="flex" justifyContent="space-between">
                    <ModelParameters
                        modelName={dosePredictionTask?.model?.label}
                        targets={dosePredictionTask?.targets}
                        version={dosePredictionTask?.model?.version}
                        isLatest={dosePredictionTask?.model?.isLatest}
                    />
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-end"
                    >
                        <Stack gap={0.5}>
                            {showPseudonymization && <PseudonymizeCheckbox />}

                            <Button
                                variant="outlined"
                                color="primary"
                                endIcon={<AutoAwesome />}
                                onClick={() =>
                                    onSubmit(dosePredictionTask?.model!.name)
                                }
                                disabled={
                                    !dosePredictionTask?.model?.name ||
                                    isLoadingSession ||
                                    isSubmitting ||
                                    !dosePredictionTask.targets?.some(
                                        (t) => t.isTarget
                                    )
                                }
                                sx={{ width: 160 }}
                                data-testid="start-dose-prediction-button"
                            >
                                <FormattedMessage id="start" />
                            </Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
